var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#ECD6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 25.25V29H14.75L25.81 17.94L22.06 14.19L11 25.25ZM13.92 27H13V26.08L22.06 17.02L22.98 17.94L13.92 27ZM28.71 13.63L26.37 11.29C26.17 11.09 25.92 11 25.66 11C25.4 11 25.15 11.1 24.96 11.29L23.13 13.12L26.88 16.87L28.71 15.04C29.1 14.65 29.1 14.02 28.71 13.63Z",
    fill: "#8C18E2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalicon);
export default __webpack_public_path__ + "static/media/Totalicon.bb969f0f9e87fe1416c2829a26452d0f.svg";
export { ForwardRef as ReactComponent };